import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    pagingSubclinicalSubject,
    getSubclinicalSubjectById,
    saveSubclinicalSubject,
    deleteSubclinicalSubject,
    getAllSubclinicalSubject
} from 'app/services/SubclinicalSubjectService';

import { SubclinicalSubject } from "app/common/Model/SubclinicalSubject";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import i18n from 'i18n';

export default class SubclinicalSubjectStore {
    listAllSubclinicalSubject = [];
    searchSubclinicalSubject = new SearchObject();
    pageSubclinicalSubject = null;
    selectedSubclinicalSubject = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteSubclinicalSubject = false;

    constructor() {
        makeAutoObservable(this);
    }

    pagingSubclinicalSubject = async () => {
        return await pagingSubclinicalSubject(this.searchSubclinicalSubject)
            .then(({ data }) => {
                this.pageSubclinicalSubject = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu đối tượng có lỗi");
            })
    }

    handleChangeFormSearch = (searchSubclinicalSubject) => {
        this.searchSubclinicalSubject = checkSearchObject(this.searchSubclinicalSubject, searchSubclinicalSubject);
        this.pagingSubclinicalSubject();
    }

    handleOpenFormCreateOrEdit = (conceptTypeId) => {
        if (Boolean(conceptTypeId)) {
            getSubclinicalSubjectById(conceptTypeId)
                .then(({ data }) => {
                    this.selectedSubclinicalSubject = data;
                    this.openFormCreateOrEdit = true;
                }).catch(function (error) {
                    console.error(error);
                    toast.error(i18n.t("management.conceptType.getDataFail"));
                });
        } else {
            this.selectedSubclinicalSubject = new SubclinicalSubject();
            this.openFormCreateOrEdit = true;
        }
    }

    saveSubclinicalSubject = async (conceptType, { setSubmitting }) => {
        return await saveSubclinicalSubject(conceptType).then(() => {
            this.selectedSubclinicalSubject = null;
            toast.success(i18n.t("management.conceptType.saveSuccess"));
            this.pagingSubclinicalSubject();
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error(i18n.t("management.conceptType.saveFail"));
        }).finally(function () {
            setSubmitting(false);
        });
    }

    handleDeleteSubclinicalSubject = (conceptType) => {
        this.selectedSubclinicalSubject = { id: conceptType?.id };
        this.openConfirmDeleteSubclinicalSubject = true;
    }

    handleConfirmDeleteSubclinicalSubject = () => deleteSubclinicalSubject(this.selectedSubclinicalSubject?.id)
        .then(() => {
            if (this.searchSubclinicalSubject.pageIndex > 1 && this.pageSubclinicalSubject?.content?.length === 1) {
                this.searchSubclinicalSubject.pageIndex -= 1;
            }
            toast.success(i18n.t("management.conceptType.deleteSuccess"));
            this.pagingSubclinicalSubject();
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error(i18n.t("management.conceptType.deleteFail"));
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteSubclinicalSubject = false;
    }

    resetStore = () => {
        this.searchSubclinicalSubject = new SearchObject();
        this.pageSubclinicalSubject = null;
        this.selectedSubclinicalSubject = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteSubclinicalSubject = false;
    }
}